var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"20px"}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdf",refInFor:true,attrs:{"src":_vm.loadingTask,"page":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }